
import ReactSVG from 'react-svg'
import {css} from 'glamor';
import * as React from 'react';
import * as globals from '../Globals/Globals'
import Draggable from 'react-draggable';
import * as papa from 'papaparse'
import { readFileSync } from 'fs';
import * as ReactDOM from 'react-dom';
import GraphCanvas from './LayoutCanvas';
import * as interactfuncs from '../libtsx/interactfuncs'
import * as fabric from 'fabric'
import classNames from 'classnames';
interface LayoutProps{
    x:number,
    y:number,
    id:string,
    yaxis:string,
    xaxis:string,
    topGraphTarget:number,
    leftGraphTarget:number,
    rightraphTarget:number,
    bottomGraphTarget:number,
    datatype:string
    className:string
    childClassName:string
  
}

interface LayoutStates{
  activeDrags?:number,
  graphAvailable?:boolean,
  expectation:string,
  className:string,
  childClassName:string
}



class LayoutDraggable extends React.Component<LayoutProps, LayoutStates>{
   
    constructor(props:any){
        super(props);
        this.state = {
          activeDrags: 0,
          expectation:'',
          className: this.props.className,
          childClassName: this.props.childClassName

        }
    }
   
    public onStart() {
      const newValue = this.state.activeDrags + 1
      this.setState({activeDrags: newValue} as LayoutStates);
    }
  
    public onStop() {
      const newValue = this.state.activeDrags - 1
      this.setState({activeDrags: newValue} as LayoutStates);
    }

  
    public render() {

          const dragHandlers = {onStart: this.onStart.bind(this), onStop: this.onStop.bind(this)};
          var style = {
              'top':this.props.y+'px',
              'left':this.props.x+'px',
              'width':400,
              'height':400,
              'position': 'absolute' as 'absolute',
              'boxSizing': 'border-box' as 'border-box'
            }
          
          console.log(this.state)
         
        return (
              <div className ={this.state.className} id={this.props.id} style={style} >
                <GraphCanvas id={this.state.childClassName} idX={this.state.childClassName+'resize-rectX'} idY={this.state.childClassName+'resize-rectY'} idZ={this.state.childClassName+'resize-rectZ'} xaxis={this.props.xaxis} yaxis={this.props.yaxis}  width={400} height={400} datatype={this.props.datatype} >
                </GraphCanvas>
              </div>
     
         
        );
      }
    componentDidMount(){
      interactfuncs.dragableDiv(this.state.className, this.state.childClassName+'resize-rectX', this.state.childClassName+'resize-rectY', this.state.childClassName+'chart',this.state.childClassName+'_mastergraphconfig',this.state.childClassName+'_svg_scatterplot_canvas',this.state.childClassName+'_menu1',this.state.childClassName+'_menu2',this.state.childClassName+'_menu3', this.state.childClassName+'resize-rectZ')
    }

      
}
export default LayoutDraggable;